// Structured identity is authoritative. Legacy sessions use the usual two-surname display format.
export const userInitials = (user, fallback = '') => {
  const value = typeof user === 'string' ? {nombreCompleto:user} : user || {};
  const words = String(value.nombreCompleto || fallback).trim().split(/\s+/).filter(Boolean);
  const first = value.primerNombre || value.nombres || words[0] || '';
  const surname = value.apellidoPaterno || (words.length > 2 ? words[words.length - 2] : words[1]) || '';
  return ([Array.from(first.trim())[0], Array.from(surname.trim())[0]].filter(Boolean).join('').toLocaleUpperCase('es') || 'U');
};
